export default function Marquee() {
  const text = "LIMITED EDITION DROPS  //  ONCE THEY ARE GONE, THEY ARE GONE  //  CREATORS · SCARCITY · OWNERSHIP  //  ";
  const line = text.repeat(4);
  return (
    <div className="border-y border-white/10 bg-[#0A0A0A] overflow-hidden py-3">
      <div className="whitespace-nowrap">
        <div className="marquee-track font-display font-black text-lg tracking-tight text-white/70">
          <span className="mr-6">{line}</span>
          <span className="mr-6">{line}</span>
        </div>
      </div>
    </div>
  );
}
